import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import styled from 'styled-components/macro';
import media from 'styles/media';
import {
  ProfileFormItems,
  ProfileFormControl,
  ProfileFormValues,
} from 'types/profile';
import * as MESSAGES from 'constants/messages';
import { NO_SELECT_NUMBER } from 'constants/form';
import { Selectbox } from 'components/atoms';
import { Field } from 'components/molecules';

type AcademicBackgroundDepartmentFormFieldProps = {
  error: string | undefined;
  departments: ProfileFormItems['departments'];
  control: ProfileFormControl<{
    academicBackground: Pick<
      ProfileFormValues['academicBackground'],
      'departmentId'
    >;
  }>;
};

const StyledSelectbox = styled(Selectbox)`
  width: 368px;

  ${media.mobile} {
    width: 100%;
  }
`;

const AcademicBackgroundDepartmentFormField: FC<AcademicBackgroundDepartmentFormFieldProps> = props => {
  const { error, departments, control } = props;

  return (
    <Field
      label={MESSAGES.PROFILE.FIELD.ACADEMIC_BACKGROUND_DEPARTMENT.LABEL}
      required
    >
      <Controller
        control={control}
        name="academicBackground.departmentId"
        render={innerProps => (
          <StyledSelectbox
            value={innerProps.value}
            error={error}
            options={departments}
            noSelectValue={NO_SELECT_NUMBER}
            aria-label={
              MESSAGES.PROFILE.FIELD.ACADEMIC_BACKGROUND_DEPARTMENT.LABEL
            }
            onChange={innerProps.onChange}
            onBlur={innerProps.onBlur}
          />
        )}
      />
    </Field>
  );
};

export default AcademicBackgroundDepartmentFormField;
